module.exports = __webpack_public_path__ + "img/pizza_pep.98b26872.png";